<template>
  <div>
    <filter-search
      @search="search"
      exportTemplate="BoardOrder"
      filename='订单信息'
    />
    <!-- 个人租赁订单 -->
    <person-rent-order-table :tableData="allTableData.personalOrderVOS"/>
    <!-- 企业租赁订单 -->
    <enterpriseRentTable :tableData="allTableData.entOrderVOS" />
  </div>
</template>
<script>
import { postStatOrder } from '@/api/domain/workbench'
import filterSearch from '../FilterSearch.vue'
import personRentOrderTable from './personRentOrderTable/index.vue'
import enterpriseRentTable from './enterpriseRentTable/index.vue'
import moment from 'moment'

export default {
  components: {
    filterSearch,
    personRentOrderTable,
    enterpriseRentTable,
  },
  data() {
    return {
      allTableData: {
        entOrderVOS: [
        ],
        personalOrderVOS: [
        ],
      },
      formData: {
        searchDate: moment().format('YYYY-MM-DD') || '',
      },
    }
  },
  methods: {
    // 搜索按钮
    search(val, cb) {
      this.formData = val
      this.postStatOrder().then(() => {
        cb()
      })
    },
    async postStatOrder() {
      const params = {
        searchType: 1,
        searchDate: this.formData.searchDate,
      }
      const { data } = await postStatOrder(params)
      this.allTableData.entOrderVOS = data?.entOrderVOS || []
      this.allTableData.personalOrderVOS = data?.personalOrderVOS || []
      return this.allTableData
    },
  },
}
</script>
